import { deepmerge } from "@mui/utils";
function createEditorCSSRules(editorThemeStyles, defaultTheme) {
  const styles = {};
  const defaultThemeStyles = structuredClone(defaultTheme);
  const mergedStyles = deepmerge(defaultThemeStyles, editorThemeStyles);
  for (const [key, value] of Object.entries(mergedStyles)) {
    switch (key) {
      case "heading":
      case "text":
      case "embedBlock": {
        for (const [subKey, subValue] of Object.entries(mergedStyles[key] ?? {})) {
          styles[`.tidalEditorLocal_${subKey}`] = {
            // @ts-expect-error
            ...defaultThemeStyles?.[key]?.[subKey],
            ...subValue
          };
        }
        break;
      }
      case "list": {
        for (const [subKey, subValue] of Object.entries(mergedStyles[key] ?? {})) {
          if (subKey === "nested") {
            if (subValue.list)
              styles[`.tidalEditorLocal_${subKey}_list`] = {
                ...defaultThemeStyles?.list?.nested?.list,
                ...subValue.list
              };
            if (subValue.listitem)
              styles[`.tidalEditorLocal_${subKey}_listitem`] = {
                ...defaultThemeStyles?.list?.nested?.listitem,
                ...subValue.listitem
              };
          } else {
            styles[`.tidalEditorLocal_${subKey}`] = {
              // @ts-expect-error
              ...defaultThemeStyles?.list?.[subKey],
              ...subValue
            };
          }
        }
        break;
      }
      default:
        styles[`.tidalEditorLocal_${key}`] = { ...defaultThemeStyles?.[key], ...value };
        break;
    }
  }
  return styles;
}
export {
  createEditorCSSRules
};
//# sourceMappingURL=createEditorCSSRules.js.map
